import React from 'react';

export const MY_ACCOUNT_PATH = '/myAccount';

export const myAccountRouteConfig = [
  {
    routes: [
      {
        path: MY_ACCOUNT_PATH,
        component: React.lazy(() => import('./MyAccount')),
      },
    ],
  },
];
